import { CountryCodeLabel } from '@org-rixsus-it/rxs-shared';
import { SelectUtils } from '@utils/Select.utils';

export const getCountriesSelectOptions = () =>
  SelectUtils.getSelectOptions(CountryCodeLabel);
